import type { PGD } from "../types";

export const protocolHydrogenPeroxideImpetigo: PGD = {
  id: "protocol-3a-h2o2-impetigo",
  reference: "3a",
  version: "1.0",
  drugRef: "hydrogen_peroxide_cream",
  indication: "Localised non-bullous impetigo — first-line topical",
  validFrom: "2024-01-31",
  expiryDate: "2027-01-30",
  frameworkType: "pharmacy_first",
  population: {
    ageRange: { min: 1, max: 999 },
    pregnancyAllowed: true,
    breastfeedingAllowed: true,
    notes: "Protocol supply; pregnant individuals must be 16+.",
  },
  duration: { days: 5 },
  doseBands: [
    {
      id: "h2o2-all",
      resolveBy: "single",
      dose: 0,
      frequency: "Up to THREE times a day",
      comment: "Single protocol band — all ages 1+.",
      formulations: [
        {
          formulationId: "h2o2-1pct-25g",
          instruction: "Apply a thin layer to the affected area(s) up to 3 times a day for 5 days",
          quantity: { tubes: 1, label: "1 × 25g tube" },
        },
        {
          formulationId: "h2o2-1pct-40g",
          instruction: "Apply a thin layer to the affected area(s) up to 3 times a day for 5 days",
          quantity: { tubes: 1, label: "1 × 40g tube" },
        },
      ],
    },
  ],
  preSupplyChecks: [
    { id: "ex-consent-refused", question: "Has the patient/carer refused consent?" },
    { id: "ex-h2o2-allergy", question: "Hypersensitivity to hydrogen peroxide or any component of the formulation?" },
    { id: "ex-failed-treatment", question: "Failed previous topical or oral treatment for this episode of impetigo?" },
    { id: "ex-active-skin", question: "Currently active underlying skin condition?", hint: "e.g. uncontrolled eczema, contact dermatitis, scabies, chickenpox, eczema herpeticum" },
    { id: "ex-open-wounds", question: "Any open wounds affecting the application area or immediate vicinity?" },
    { id: "ex-fire-risk", question: "Inability to stay away from open or naked flames?", hint: "e.g. smokers — risk of severe burns" },
    { id: "ex-breastfeeding-breast", question: "Breastfeeding with impetigo lesion(s) on the breast(s)?" },
    { id: "int-topical-iodine", question: "Currently using topical iodine, permanganates, or other strong oxidising agents on the affected area?" },
  ],
  cautions: [
    { id: "caution-breastfeeding", text: "Breastfeeding (lesions not on breast) — avoid direct contact between infant and lesions. Wash hands after applying and before touching infant." },
    { id: "caution-dry-film", text: "A dry film will appear on the skin after each application — this can be washed off with water." },
  ],
  counselling: [
    "Apply a thin layer to the affected area(s) up to 3 times a day for 5 days",
    "A dry white film will appear after application — this is normal and can be washed off with water",
    "Wash hands thoroughly after each application",
    "Good hygiene is important to reduce spread",
  ],
  counsellingPoints: [
    { text: "Apply a thin layer to the affected area(s) up to 3 times a day for 5 days" },
    { text: "A dry white film will appear after application — this is normal and can be washed off with water" },
    { text: "Wash hands thoroughly after each application" },
    { text: "Good hygiene is important to reduce spread — avoid touching lesions, wash hands frequently, do not share towels or flannels" },
    { text: "Keep away from school/nursery/work until lesions are crusted and dried, or 48 hours after starting treatment" },
    { text: "Return to pharmacy if symptoms worsen at any time or do not improve after completing the 5-day course" },
  ],
  outcomeLinkRefs: ["bad-impetigo-leaflet", "nhs-impetigo"],
};
